import { Component, input } from '@angular/core';

export type IconName =
  | 'globe'
  | 'info'
  | 'close'
  | 'user'
  | 'back'
  | 'edit'
  | 'discardChanges'
  | 'gallery-close'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'chevron-down'
  | 'plus'
  | 'search'
  | 'expand'
  | 'delete'
  | 'collapse'
  | 'copy'
  | 'virtualAssistant'
  | 'word'
  | 'excel'
  | 'pdf'
  | 'text'
  | 'gaeb'
  | 'datanorm'
  | 'oenorm';

@Component({
  selector: 'app-icon',
  imports: [],
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="size()"
      [attr.height]="size()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [attr.stroke]="stroke()"
      aria-hidden="true"
      focusable="false"
    >
      @switch (name()) {
        @case ('globe') {
          <g stroke-miterlimit="10" stroke-width="2" transform="translate(-3 -3)">
            <circle cx="11" cy="11" r="11" transform="translate(4 4)" />
            <ellipse cx="5" cy="11" rx="5" ry="11" transform="translate(10 4)" />
            <path d="M4.5 11h21m-21 8h21" />
          </g>
        }
        @case ('info') {
          <path d="M13 16.5h2.5v2H9v-2h2v-5H9v-2h4v7ZM12 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
        }
        @case ('close') {
          <g>
            <circle cx="12" cy="12" r="11.5" fill="currentColor" />
            <path
              d="M8 8 L16 16 M16 8 L8 16"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
            />
          </g>
        }
        @case ('user') {
          <g stroke-miterlimit="10" stroke-width="2">
            <path d="M12 1a11 11 0 1 0 11 11A11.032 11.032 0 0 0 12 1Z" />
            <path
              d="M12 4.171a3.6 3.6 0 1 1-3.6 3.6 3.612 3.612 0 0 1 3.6-3.6Zm0 15.759a7.316 7.316 0 0 1-6.2-3.842c.05-2.4 4.133-3.721 6.2-3.721s6.15 1.321 6.2 3.721A7.328 7.328 0 0 1 12 19.93Z"
            />
          </g>
        }
        @case ('back') {
          <path stroke-width="2" d="M3.5 12h18M8.8 6.759l-5.359 5.165 5.359 5.36" />
        }
        @case ('edit') {
          <path
            stroke-width="2"
            d="m14.237 6.404 3.536 3.536-9.425 9.424-3.746.022.21-3.558Zm6.924 1.456-4.936-4.963Z"
          />
        }
        @case ('discardChanges') {
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
          />
        }
        @case ('gallery-close') {
          <g>
            <circle cx="12" cy="12" r="11.5" />
            <path
              d="M8 8 L16 16 M16 8 L8 16"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
            />
          </g>
        }
        @case ('chevron-left') {
          <path
            d="M15 18 L9 12 L15 6"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        }
        @case ('chevron-right') {
          <path
            d="M9 6 L15 12 L9 18"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        }
        @case ('chevron-up') {
          <path
            d="M6 15 L12 9 L18 15"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        }

        @case ('chevron-down') {
          <path
            d="M6 9 L12 15 L18 9"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        }
        @case ('plus') {
          <path d="M12 5v14M5 12h14" stroke-width="2" />
        }
        @case ('search') {
          <path
            stroke-miterlimit="10"
            d="M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10Z"
          />
          <path d="m18.5 18.5 5 5" />
        }
        @case ('expand') {
          <g stroke-miterlimit="10" stroke-width="2">
            <path d="M12 3a9 9 0 1 0 9 9 9.026 9.026 0 0 0-9-9Z" />
            <path d="m16.693 9.827-4.562 4.241-4.438-4.241" />
          </g>
        }
        @case ('delete') {
          <path
            stroke-width="2"
            d="M5.667 7.778V21.5h12.666V7.778M7.778 2.5h8.444M2.5 6.722h19m-7.389 3.167v8.444M9.889 9.889v8.444"
          />
        }
        @case ('collapse') {
          <g stroke-width="2">
            <path d="M12 3a9 9 0 1 0 9 9 9.026 9.026 0 0 0-9-9Z" />
            <path d="m7.693 14.069 4.562-4.241 4.438 4.241" />
          </g>
        }
        @case ('copy') {
          <path d="M6 19H22V5.34814L17.5556 1H6V19Z" stroke-width="2" fill="none" />
          <path d="M1.5 5V23H17.5" fill="none" stroke-width="2" />
        }
        @case ('virtualAssistant') {
          <path d="M22 24h-20v-24h14.4l5.6 5.355Z" fill="#545454" />
          <path d="M4 22h16v-15.79l-4.4-4.21H4Z" fill="#545454" />
          <path d="M3 23h18v-17.217l-5-4.783H3Z" fill="#f9f300" />
          <circle cx="12.1" cy="6.5" r="1.35" fill="#545454" />
          <path d="M9.8 10.25h3.8v1.2h-0.5v5.684h1v1.2h-4v-1.2h1v-5.684h-1.3Z" fill="#545454" />
        }
        @case ('word') {
          <path
            fill="currentColor"
            stroke="none"
            fill-rule="nonzero"
            d="M16.401 0H2v24h20V5.356L16.401 0Zm-.802 2L20 6.21V22H4V2h11.599Z"
          />
          <path
            fill="currentColor"
            stroke="none"
            fill-rule="nonzero"
            d="M10.44 17 12.04 10.58 13.54 17h2.88l1.48-8.664h-2.168l-.8 6.264-1.288-6.264H10.7L9.288 14.648 8.488 8.336H6.1L7.572 17Z"
          />
        }
        @case ('excel') {
          <g transform="translate(3 1)" fill="currentColor" stroke="none" fill-rule="nonzero">
            <path
              d="M13.401281,-1 L-1,-1 L-1,23 L19,23 L19,4.35573456 L13.401281,-1 Z M12.599,1 L17,5.21 L17,21 L1,21 L1,1 L12.599,1 Z"
            />
            <polygon
              transform="translate(4 7)"
              points="2.9 9 4.82 5.916 6.72 9 9.792 9 6.552 4.44 9.636 0.336 6.876 0.336 5.124 3.024 3.432 0.336 0.336 0.336 3.384 4.488 0.1 9"
            />
          </g>
        }
        @case ('pdf') {
          <g transform="translate(2)" fill="currentColor" stroke="none" fill-rule="nonzero">
            <path d="M14.401 0H0v24h20V5.356L14.401 0Zm-.802 2L18 6.21V22H2V2h11.599Z" />
            <path
              d="M8.50802975,7.04833002 C8.88874157,6.12920052 10.0850973,6.17806856 10.6171928,7.03948537 L10.6854949,7.16197316 L10.7013986,7.20197009 C11.0033771,8.20562585 11.0007044,9.27409495 10.7027425,10.254892 L10.614166,10.5200938 L10.34,11.59 L10.5497073,11.9469014 C10.6792067,12.1464403 10.8132483,12.342947 10.9517497,12.536304 L11.1628362,12.8239622 L11.4918734,13.2463974 L12.115,14.023 L12.8626803,13.9250979 C15.3674659,13.5985415 16.7345124,14.0261297 16.9056529,15.0878306 L16.9194106,15.2040053 L16.924,15.325 C16.924,16.7981161 14.392012,16.8029573 12.4637327,15.4481738 C12.2905412,15.3257983 12.124152,15.1941988 11.9652766,15.05397 L11.831,14.929 L11.2840912,15.0462455 L10.762978,15.1625982 L10.3473042,15.2627874 L9.70845289,15.4416994 L9.08271709,15.6425389 L8.581,15.81 L8.14030466,16.4848322 C7.57051152,17.5058145 6.79503454,18.3974376 5.86736538,19.0998612 C5.26601709,19.5768761 4.42453543,19.6080421 3.7532233,19.1467767 C2.88136498,18.2749184 3.68452382,17.1887801 5.75955949,16.1133291 L5.97873884,16.0021229 L7.221,15.384 L7.81111144,14.090007 L8.05786422,13.5211487 L8.31052394,12.9169544 L8.53830079,12.3510087 L9.026,11.07 L8.7640938,10.3295516 C8.45611043,9.48389576 8.33749157,8.58349461 8.42169703,7.66387066 L8.45729599,7.35666611 L8.50802975,7.04833002 Z M6.2516859,16.8964644 L6.363,16.732 L6.13458397,16.8472148 C4.67610031,17.5828375 4.04460209,18.2361196 4.25674919,18.4915873 C4.3608023,18.615967 4.47474487,18.6184553 4.81300388,18.4208031 L4.909,18.362 L5.14250686,18.1562916 C5.55393156,17.775663 5.92529182,17.3539011 6.2516859,16.8964644 Z M14.0819043,14.6167866 L13.8621386,14.6384118 L13.5303249,14.6661208 L12.937,14.728 L13.0740568,14.812571 C13.5421265,15.0578987 14.0306274,15.2620921 14.5315215,15.4220552 C14.9106347,15.5387055 15.1287606,15.5468373 15.2791854,15.470969 L15.3326034,15.4386288 L15.3977744,15.3868749 C15.4502095,15.3319928 15.4834281,15.2614149 15.4923046,15.1860312 L15.4928772,15.1094491 C15.4796754,14.9804868 15.3962732,14.8693842 15.2733997,14.8195827 C14.8961129,14.6615222 14.4884425,14.5925458 14.0819043,14.6167866 Z M9.957,12.574 L9.80723315,13.0016597 L9.71596098,13.2391646 L9.102,14.745 L9.42328227,14.6459207 L9.75696307,14.5465802 L10.1270937,14.4466819 L10.6812389,14.3194085 L11.212,14.207 L11.0998529,14.0688809 C10.8484298,13.7884314 10.6122823,13.4947726 10.3966557,13.1951099 L10.1880637,12.8937128 L10.0029123,12.6418338 L9.957,12.574 Z M9.19727843,8.29101941 C9.22636287,8.65776811 9.2814465,9.02227866 9.36090321,9.37768704 L9.437,9.685 L9.49824675,9.43720215 C9.53583225,9.27215797 9.57071887,9.10587172 9.60300883,8.93780295 L9.69219094,8.42770858 C9.77738538,8.05204133 9.75333857,7.65812514 9.67291452,7.37805762 C9.40307835,7.08088122 9.12704842,7.36866518 9.19727843,8.29101941 Z"
            />
          </g>
        }
        @case ('text') {
          <g stroke="currentColor" stroke-width="2" fill="none">
            <path d="M5 2h9.5L19 6.5V22H5Z" />
            <path d="M9 10h7M9 14h7M9 18h7" />
          </g>
        }
        @case ('gaeb') {
          <g transform="translate(0 0.923) scale(0.9231)" stroke="none" fill="currentColor">
            <g transform="translate(0.35 7.5)" fill-rule="nonzero">
              <path
                d="M21.627,0.5 C21.7382559,0.500505556 21.8494086,0.506847605 21.96,0.519 L22.036,0.528 C22.3213469,0.562862225 22.600794,0.635498295 22.867,0.744 C23.8241147,1.11365698 24.4424341,2.04855901 24.408,3.074 C24.4238738,3.61889589 24.2628384,4.15427704 23.949,4.6 C24.390143,5.02427489 24.6423599,5.60797693 24.649,6.22 C24.5951811,7.29438763 23.8932001,8.22798674 22.876,8.578 C22.6043996,8.69142051 22.3188807,8.76809698 22.027,8.806 C21.8944268,8.8245107 21.7608422,8.83486351 21.627,8.837 L18.72,8.837 L18.72,6.658 L21.63,6.658 L21.675,6.658 L21.735,6.651 C21.8352056,6.63837598 21.9333549,6.61283028 22.027,6.575 C22.19,6.506 22.227,6.452 22.227,6.236 C22.227,6.02 22.188,5.97 22.034,5.907 C21.9456937,5.87223333 21.8532594,5.84904073 21.759,5.838 L21.7,5.828 L21.651,5.828 L18.72,5.828 L18.72,3.512 L21.63,3.512 L21.675,3.512 L21.735,3.505 C21.8352056,3.49237598 21.9333549,3.46683028 22.027,3.429 C22.19,3.36 22.227,3.306 22.227,3.09 C22.227,2.874 22.188,2.824 22.034,2.761 C21.9456937,2.72623333 21.8532594,2.70304073 21.759,2.692 L21.7,2.681 L21.651,2.681 L18.72,2.681 L18.72,0.5 L21.626,0.5 L21.627,0.5 Z M8.312,0.539 L8.312,2.717 L4.953,2.717 L4.884,2.725 L4.852,2.725 L4.777,2.737 L4.689,2.753 L4.641,2.763 C3.74582284,2.99249364 3.12885404,3.81124361 3.155,4.735 C3.07099974,5.57994017 3.60223803,6.36438942 4.418,6.6 L4.506,6.624 L4.581,6.642 L4.647,6.656 L6.626,6.656 L7.238,5.7 L4.728,5.7 L4.728,3.525 L8.639,3.525 L10.558,0.539 L17.9,0.539 L17.9,2.718 L14.353,2.718 L14.353,3.526 L18.039,3.526 L18.039,5.7 L14.353,5.7 L14.353,6.655 L18.039,6.655 L18.039,8.836 L11.933,8.836 L11.933,6.671 L9.205,6.671 L7.815,8.835 L4.495,8.835 L4.384,8.821 L4.284,8.805 C4.159,8.782 4,8.747 3.825,8.7 C3.39217081,8.57922075 2.97723362,8.40167874 2.591,8.172 C1.30356338,7.43700159 0.550477549,6.02992017 0.653,4.551 C0.657566483,3.07977188 1.50447423,1.741199 2.832,1.107 C3.26455111,0.888062621 3.72471987,0.728618183 4.2,0.633 C4.328,0.607 4.444,0.587 4.548,0.572 L4.667,0.557 L4.721,0.552 L4.821,0.544 L4.893,0.544 L8.312,0.539 Z M11.747,2.717 L10.606,4.493 L11.934,4.493 L11.934,2.717 L11.747,2.717 Z"
              />
            </g>
            <path
              fill-rule="nonzero"
              d="M5,18 L5,22 L21,22 L21,18 L23,18 L23,24 L3,24 L3,18 L5,18 Z M3,0 L17.401281,0 L22.6912522,5.06038639 L21.3087478,6.50561361 L16.599,2 L5,2 L5,6 L3,6 L3,0 Z"
            />
          </g>
        }
        @case ('datanorm') {
          <g stroke="currentColor" stroke-width="2" fill="none">
            <path d="M3 23h18V5.783l-5-4.783H3Z" />
            <path d="M8 11V7h8v4" />
            <path d="M8 16.78v-4h8v4" />
          </g>
        }
        @case ('oenorm') {
          <g stroke="currentColor" stroke-width="2" fill="none" stroke-linejoin="bevel">
            <path d="M3 23h18V5.783l-5-4.783H3Z" />
            <path d="M14 5v13L10 9v9" />
            <circle cx="12" cy="13.553" r="5" />
          </g>
        }
      }
    </svg>
  `,
  styles: `
    svg {
      display: block;
    }
  `,
})
export class Icon {
  name = input.required<IconName>();
  size = input<number>(24);
  viewBox = input<string>('0 0 24 24');
  fill = input<string>('none');
  stroke = input<string>('currentColor');
}
